import { createAsyncThunk } from '@reduxjs/toolkit';
import adserver from 'services/adserver';
import { withErrorHandling } from 'store/wrappers';
import { REDUCER_KEY } from './committedBaskets.consts';
import { fetchCommittedProposalsOfBasket } from 'store/proposals/committed';
import { fetchAllCommittedOrdersOfCommittedBasket } from 'store/orders/committed';

export const fetchCommittedBasketById = createAsyncThunk(
  REDUCER_KEY + '/fetchCommittedBasketById',
  withErrorHandling(async (basketId: number, thunkAPI: any) => {
    const response = await adserver({
      url: `/basket/${basketId}/committed`,
      method: 'GET',
      headers: {},
    });
    thunkAPI.dispatch(fetchCommittedProposalsOfBasket({ basketId }));
    thunkAPI.dispatch(fetchAllCommittedOrdersOfCommittedBasket({ basketId }));
    return response.data;
  }),
);

export const removeAllBaskets = (): { type: string } => ({
  type: REDUCER_KEY + '/removeAll',
});
